import React, { useCallback } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import cx from 'classnames';


export const SectionLink = ({ to, icon: _icon, text, ...props}) => {
    const match = useRouteMatch(to);
    
    const Icon = useCallback((p) => ( <_icon {...p} />), [_icon]);

    return (
        <Link replace={true} className={cx('z-10 flex flex-col items-center h-full w-24 text-sm font-semibold', match ? 'text-blue-60' : 'text-gray-410')} to={to} {...props}>
            <div className={cx('h-16 w-16 mx-auto rounded-md mt-0 mb-2 flex items-center justify-center', match ? 'bg-blue-30' : 'bg-blueGray-30')}>
                <Icon size='2rem' className={cx(match ? 'text-blue-60' : 'text-blue-30')}/>
            </div>
            <div className="text-xs text-center mt-0">{text}</div>
        </Link>
        
    );
};

const SectionNav = ({children}) => {

    const links = React.Children.map(children, child => {
        return child.type.name == SectionLink.name ? child : null;
    });

    return (
        <section className="h-40 px-4 pt-8 flex items-stretch justify-between relative">
            <div className="absolute top-16 left-1/2 transform -translate-x-1/2 w-11/12 border-t-2 border-blueGray-30"/>
            {links}
        </section>
    );
};

SectionNav.Link = SectionLink;

export default SectionNav;